// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"4fe21479","168":"036f13d3","180":"f7bb0751","269":"d8ce96ea","486":"363dc907","640":"f5ffdb6c","727":"c199e2aa","886":"7d77aee7","925":"65ef41b6","959":"835aa2ac"}[chunkId] + ".chunk.js";
};